import React, { useState, useEffect } from "react";
import { Link, NavLink, useHistory } from "react-router-dom";
import "./oder.scss";
import Environment from "utils/environment";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Spinner from "react-bootstrap/Spinner";
import Offcanvas from "react-bootstrap/Offcanvas";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import moment from "moment";
import Dropdown from 'react-bootstrap/Dropdown';

const Order = () => {
  const [show, setShow] = useState(false);
  const val = localStorage.getItem("accessToken");
  const api_url = Environment.base_url;
  const history = useHistory();
  const [loader, setLoader] = useState(false);
  const [pageCount, setPageCount] = useState([]);
  const [offset, setOffset] = useState(1);
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(0);
  const [limit, setLimit] = useState(10);
  const [orderList, setOrderList] = useState([]);
  const [orderStats, setOrderStats] = useState([]);
  const [currentView1, setCurrentView1] = useState(true);
  const [activeFilter, setActiveFilter] = useState("none");
  const [date, setdate] = useState('');
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const getCustomerOrders = async () => {
    setLoader(true);
    if (activeFilter === 'getCustomerOrders') {
      setActiveFilter('none');
      return;
    }
    setActiveFilter('getCustomerOrders');
    setOrderList([]);
    const config = {
      method: "get",
      url:
        api_url +
        "/orders?limit=" +
        limit +
        "&offset=" +
        offset +
        "&sort[]=createdAt@desc",
      headers: {
        Authorization: "Bearer " + val,
      },
    };

    await axios(config)
      .then((res) => {
        const resData = res?.data?.data;
        console.log("orders list: ", resData);
        setOrderList(resData?.orders);
        let arr = Array.from(Array(parseInt(resData.pages)).keys());
        setCount(resData?.count);
        setPage(resData?.pages);
        setPageCount(arr);
        setLoader(false);
        setdate(moment(resData?.data?.createdAt).format("DD MMM YYYY, h:mm A"));
        
      })
      .catch((err) => {
        if (err?.response?.status == 501) {
          localStorage.removeItem("accessToken");
          history.push("/");
        } else if (err?.response?.status == 401) {
          localStorage.removeItem("accessToken");
          history.push("/");
           console.log("refresh token: ", err?.response);
        }
        console.log("error meessage: ", err?.response?.data?.message);
        toast.error(err?.response?.data?.message, {
          position: "top-right",
          autoClose: 2000,
        });
        setLoader(false);
      });
    
  };

  const getOrderStats = async () => {
    setLoader(true);
    setOrderStats([]);
    const config = {
      method: "get",
      url: api_url + "/orders/stats",
      headers: {
        Authorization: "Bearer " + val,
      },
    };
    await axios(config)
      .then((res) => {
        const resData = res?.data?.data;
        console.log("order stats: ", resData);
        setOrderStats(resData);
        
      })
      
      .catch((error) => {
        if (error?.response?.status == 501) {
          localStorage.removeItem("accessToken");
          history.push("/");
        }
      });
  };

  const changeOrderStatus = async (id, status) => {
    const config = {
      method: "patch",
      url: api_url + "/orders/" + id + "/status",
      data: { status: status },
      headers: {
        Authorization: "Bearer " + val,
      },
    };

    await axios(config)
      .then((res) => {
        console.log("order status: ", res);
        toast.success(res?.data?.message);
        getCustomerOrders();
        window.location.reload();

      })
      .catch((error) => {
        if (error?.response?.status == 501) {
          toast.error("Jwt expired/invalid", {
            position: "top-right",
            autoClose: 3000,
          });
          localStorage.removeItem("accessToken");
          history.push("/");
        } else if (error?.response?.status == 401) {
          toast.error("Jwt expired/invalid", {
            position: "top-right",
            autoClose: 3000,
          });
          localStorage.removeItem("accessToken");
          history.push("/");
        } else {
          toast.error(error?.response?.data?.message, {
            position: "top-right",
            autoClose: 3000,
          });
        }
      });
  };

  useEffect(() => {
    if (!val) {
      history.push("/");
    } else {
      getCustomerOrders();
      getOrderStats();
    }
  }, [offset]);



  const statusConfig = {
    pending: { label: "Pending", className: "greenprocesssyellow" },
    processing: { label: "Confirmed", className: "greenprocesss" },
    delivered: { label: "Dispatched", className: "greenprocesssgreen" },
    cancelled: { label: "Cancelled", className: "greenprocesssred" }
  };

  const statusOptions = ["pending", "processing", "delivered", "cancelled"];

  const disabledMap = {
    processing: ["pending"],
    delivered: ["pending", "processing", "cancelled"],
    cancelled: ["pending", "processing", "delivered"],
    refund: ["pending", "processing", "delivered", "cancelled"]
  };



  const OrderProcessing = async () => {

    if (activeFilter === 'OrderProcessing') {
      setActiveFilter('none');
      getCustomerOrders();
      return;
    }
    setActiveFilter('OrderProcessing');
    setLoader(true);
    setOrderList([])
    try {
      const response = await axios.get(
        `${api_url}/orders?limit=${limit}&offset=${offset}&sort%5B%5D=createdAt@desc&&searchByName=false&filter=status=eq:processing`,
        {
          headers: {
            Authorization: "Bearer " + val,
          },
        }
      );
      const resData = response?.data?.data?.orders
      console.log("Products Data:", resData);
      setOrderList(resData)
      let arr = Array.from(Array(parseInt(response.data.data.pages)).keys());
      setCount(response.data.data.count);
      setPage(response.data.data.pages);
      setPageCount(arr);
      setLoader(false);
    } catch (error) {
      setLoader(false);
      if (error?.response?.status === 501) {
        localStorage.removeItem("accessToken");
        history.push("/");
      }
      console.error("Error fetching order stats:", error);
    }
  }

  const Orderdelivered = async () => {

    if (activeFilter === 'Orderdelivered') {
      setActiveFilter('none');
      getCustomerOrders();
      return;
    }
    setActiveFilter('Orderdelivered');
    setOrderList([]);
    setLoader(true);
    try {
      const response = await axios.get(
        `${api_url}/orders?limit=${limit}&offset=${offset}&sort%5B%5D=createdAt@desc&&searchByName=false&filter=status=eq:delivered`,
        {
          headers: {
            Authorization: "Bearer " + val,
          },
        }
      );
      const resData = response?.data?.data?.orders
      console.log("Products Data:", resData);
      setOrderList(resData)
      let arr = Array.from(Array(parseInt(response.data.data.pages)).keys());
      setCount(response.data.data.count);
      setPage(response.data.data.pages);
      setPageCount(arr);
      setLoader(false);
    } catch (error) {
      setLoader(false);
      if (error?.response?.status === 501) {
        localStorage.removeItem("accessToken");
        history.push("/");
      }
      console.error("Error fetching order stats:", error);
    }
  }

  const OrderPending = async () => {
    if (activeFilter === 'OrderPending') {
      setActiveFilter('none');
      getCustomerOrders();
      return;
    }
    setActiveFilter('OrderPending');
    setLoader(true);
    setOrderList([]);
    setLoader(true);
    try {
      const response = await axios.get(
        `${api_url}/orders?limit=${limit}&offset=${offset}&sort%5B%5D=createdAt@desc&&searchByName=false&filter=status=eq:pending`,
        {
          headers: {
            Authorization: "Bearer " + val,
          },
        }
      );
      const resData = response?.data?.data?.orders
      console.log("Products Data:", resData);
      setOrderList(resData)
      let arr = Array.from(Array(parseInt(response.data.data.pages)).keys());
      setCount(response.data.data.count);
      setPage(response.data.data.pages);
      setPageCount(arr);
      setLoader(false);
    } catch (error) {
      setLoader(false);
      if (error?.response?.status === 501) {
        localStorage.removeItem("accessToken");
        history.push("/");
      }
      console.error("Error fetching order stats:", error);
    }
  }


  const [searchQuery, setSearchQuery] = useState("");
  const [searchBy, setSearchBy] = useState("Name"); 
  const searchParamMap = {
    Name: "searchByName",
    Email: "searchByEmail",
    "Order ID": "searchByOrderId",
    "Phone No": "searchByPhone",
  };

 
 const searchOrders = async () => {
  if (!searchBy || !searchQuery.trim()) return;

  setLoader(true);
    setOrderList([])

  try {
    const searchKeyMap = {
      Name: "name",
      Email: "email",
      "Order ID": "id",
      "Phone No": "phone",
    };

    const searchKey = searchKeyMap[searchBy];

    const response = await axios.get(
      `${api_url}/orders`,
      {
        headers: {
          Authorization: "Bearer " + val,
        },
        params: {
          limit: 10,
          offset: 1,
          'sort[]': 'createdAt@desc',
          search: `${searchKey}=${searchQuery.trim()}`,
          searchByName: searchBy === "Name",  
        },
      }
    );
    const resData = response?.data?.data?.orders
      console.log("Products Data:", resData);
      setOrderList(resData)

     const arr = Array.from(
      Array(parseInt(response.data.data.pages)).keys()
    );
    setPage(response.data.data.pages);
    setPageCount(arr);
  } catch (error) {
    console.error("Search Error:", error?.response?.data || error);
  } finally {
    setLoader(false);
  }
};


  useEffect(() => {
    if (searchQuery.trim().length === 0 || !searchBy) return;

    const delayDebounce = setTimeout(() => {
      searchOrders();
    }, 500);

    return () => clearTimeout(delayDebounce);
  }, [searchQuery, searchBy]);





  return (
    <>
      <div className="contentssss">
        <section className="main-Productsss">
          <div className="row">
            <div className="col-sm-12 p-0">
              <div className="Overview_main">
                <h4 className="headdingg">Orders#9AF3DF</h4>
              
                <div className="search-field w-100">
                  <img
                    src="/nav-assets/search-normal.svg"
                    alt="search"
                    className="search-icon"
                  />
                  <input
                    type="text"
                    placeholder="Search"
                    className="parent-input"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                  />

                  <div className="dropdown dropdown-text-parent">
                    <h6
                      className="dropdown-text"
                      type="button"
                      id="dropdownMenuButton"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      By {searchBy || "Filter"}
                      <img
                        src="/assestsss/arrow1.svg"
                        alt="arrow"
                        className="img-fluid ml-1"
                      />
                    </h6>

                    <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                      {["Name", "Email", "Order ID", "Phone No"].map((label) => (
                        <div className="input-field" key={label}>
                          <input
                            className="form-check-input"
                            type="radio"
                            name="searchType"
                            value={label}
                            checked={searchBy === label}
                            onChange={() => setSearchBy(label)}
                          />
                          <label className="ml-1">{label}</label>
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* Loader and Results */}
                  {loader ? (
                    <p>Loading...</p>
                  ) : (
                    <div>
                      {/* <h6>Results:</h6> */}
                      {orderList.length === 0 ? (
                        <p>No results found.</p>
                      ) : (
                        <ul>
                          {orderList.map((item, index) => (
                            <li key={index}>{item?.name}</li>
                          ))}
                        </ul>
                      )}
                    </div>
                  )}
                </div>

              </div>
              <div className="row ">
                <div className="col-xl-3 col-lg-6 col-md-6 col-sm-12 pl-0 padd-l padd"
                  onClick={getCustomerOrders}
                >
                  <div className="carddashbord">
                    <div className="carrdmainflex"
                      style={{
                        cursor: 'pointer',
                        border: activeFilter === 'getCustomerOrders' ? '2px solid #009DE0' : '', // Add a default border for consistency
                        borderRadius: '10px',
                      }}>
                      <div className="cardpic">
                        <img
                          src="\dashbord\cardfst.svg"
                          alt="img"
                          className=""
                        />
                      </div>
                      <div className="cardpichnd">
                        <p className="headdinggfst">Total Order</p>
                        {orderStats != null ||
                          Object.keys(orderStats).length > 0 ? (
                          <p className="headdinggfstdd">
                            {" "}
                            {orderStats?.totalOrder}
                          </p>
                        ) : (
                          0
                        )}

                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xl-3 col-lg-6 col-md-6 col-sm-12 padd-r padd"
                  onClick={OrderPending}
                >
                  <div className="carddashbord">
                    <div className="carrdmainflex"
                      style={{
                        cursor: 'pointer',
                        border: activeFilter === 'OrderPending' ? '2px solid #009DE0' : '',
                        borderRadius: '10px',

                      }}
                    >
                      <div className="cardpic">
                        <img
                          src="\dashbord\cardsec.svg"
                          alt="img"
                          className=""
                        />
                      </div>
                      <div className="cardpichnd">
                        <p className="headdinggfst">Order Pending</p>
                        {orderStats != null ||
                          Object.keys(orderStats).length > 0 ? (
                          <p className="headdinggfstdd">
                            {" "}
                            {orderStats?.pendingOrder}
                          </p>
                        ) : (
                          0
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xl-3 col-lg-6 col-md-6 col-sm-12 padd thrdpadd"
                  onClick={OrderProcessing}

                >
                  <div className="carddashbord">
                    <div className="carrdmainflex"
                      style={{
                        border: activeFilter === 'OrderProcessing' ? '2px solid #009DE0' : '', 
                        borderRadius: '10px',
                        cursor: 'pointer',
                      }}>
                      <div className="cardpic">
                        <img
                          src="\dashbord\cardthrd.svg"
                          alt="img"
                          className=""
                        />
                      </div>
                      <div className="cardpichnd">
                        <p className="headdinggfst">Order Processing</p>
                        {orderStats != null ||
                          Object.keys(orderStats).length > 0 ? (
                          <p className="headdinggfstdd">
                            {" "}
                            {orderStats?.processingOrder}
                          </p>
                        ) : (
                          0
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xl-3 col-lg-6 col-md-6 col-sm-12  pr-0 padd-r padd"
                  onClick={Orderdelivered}
                >
                  <div className="carddashbord">
                    <div className="carrdmainflex"
                      style={{
                        cursor: 'pointer',
                        border: activeFilter === 'Orderdelivered' ? '2px solid #009DE0' : '', 
                        borderRadius: '10px',

                      }}
                    >
                      <div className="cardpic">
                        <img
                          src="\dashbord\cardfor.svg"
                          alt="img"
                          className=""
                        />
                      </div>
                      <div className="cardpichnd">
                        <p className="headdinggfst">Order Delivered</p>
                        {orderStats != null ||
                          Object.keys(orderStats).length > 0 ? (
                          <p className="headdinggfstdd">
                            {" "}
                            {orderStats?.deliveredOrder}
                          </p>
                        ) : (
                          0
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="table-responsive">
                <table class="table bashbord_table">
                  <thead className="bashbord_table_head">
                    <tr className="tablerow">
                      <th scope="col">Order id</th>
                      <th scope="col">createdAt</th>
                      <th scope="col">Customer</th>
                       <th scope="col">Order Type</th>
                      <th scope="col">Amount</th>
                      <th scope="col">Status</th>
                       <th scope="col">Details</th>
                    </tr>
                  </thead>
                  <tbody>
                    {orderList?.length > 0
                      ? orderList?.map((item) => {
                        return (
                          <>
                            <tr className="fstrowtable">
                              <td>
                                <p className="fstrownum">{item?.id}</p>{" "}
                              </td>
                              <td>
                                <p className="fstrownum">{date}</p>{" "}
                              </td>
                              <td className="avtimgandname">
                                <p className="fstrownumsec ">
                                   
                                  {item?.user?.name}
                                </p>
                              </td>
                              <td>

                                <p className="fstrownumfour"
                                  style={{
                                    background:
                                      item.type === "pickUp"
                                        ? "#E000AF"
                                        : item.type === "standard"
                                          ? "#615ACA" : "",
                                    maxWidth:
                                      item.type === "standard"
                                        ? "128px" : "",

                                  }}

                                >
                                  {item?.type === 'pickUp' ? 'Self Pickup' : item?.type === 'standard' ? 'Standard Delivery' : ''}

                                </p>

                              </td>
                              <td>

                                <p
                                style={{
                                  fontWeight: 'bold',
                                  color: '#009de0'
                                }}
                                
                                >
                                  {item?.total}
                                 </p>
                              </td>

                              <td>
                                <div className="dropdownsss">
                                  <Dropdown>
                                    <Dropdown.Toggle
                                      style={{
                                        fontSize: "12px",
                                        fontStyle: "normal",
                                        fontWeight: 500,
                                        lineHeight: "100%",
                                        borderRadius: "30px",
                                        background:
                                          item.status === "pending"
                                            ? "#FFB800"
                                            : item.status === "processing"
                                              ? "#009DE0"
                                              : item.status === "delivered"
                                                ? "#00AE11"
                                                : item.status === "cancelled" || item.status === "refund"
                                                  ? "#E15151"
                                                  : "#E000AF",
                                        border: "none",
                                        maxWidth: "93px",
                                        color: "#fff",
                                        width: "100%",
                                        display: "flex",
                                        alignItems: "center",
                                        padding: "5px 10px",
                                        justifyContent: "center"
                                      }}
                                      variant="success"
                                      id="dropdown-basic"
                                    >
                                      <span title={item.status}>
                                        {statusConfig[item.status === "refund" ? "cancelled" : item.status]?.label || item.status}
                                      </span>
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu className="dropbody">
                                      {statusOptions.map((status) => {
                                        const originalStatus = item.status === "refund" ? "cancelled" : item.status;
                                        const isDisabled =
                                          disabledMap[item.status]?.includes(status) || originalStatus === status;

                                        return (
                                          <Dropdown.Item
                                            key={status}
                                            onClick={() => {
                                              if (!isDisabled) {
                                                changeOrderStatus(item.id, status);
                                              }
                                            }}
                                            disabled={isDisabled}
                                            style={{
                                              color: isDisabled ? "#999" : "#7a7b96",
                                              cursor: isDisabled ? "not-allowed" : "pointer"
                                            }}
                                          >
                                            <input
                                              type="checkbox"
                                              checked={status === (item.status === "refund" ? "cancelled" : item.status)}
                                              readOnly
                                              className="mr-2"
                                            />
                                            {statusConfig[status]?.label}
                                          </Dropdown.Item>
                                        );
                                      })}
                                    </Dropdown.Menu>
                                  </Dropdown>
                                </div>





                              </td>
                              <td>
                                {" "}
                                {/* <a className="tble_details">Details</a> */}
                                <Link
                                  to={{
                                    pathname: "/admin/orderdetail",
                                    state: {
                                      id: item?.id,
                                      type: item?.type,
                                    },
                                  }}
                                  className="tble_details"
                                >
                                  Details
                                </Link>
                              </td>
                            </tr>
                          </>
                        );
                      })
                      : null}
                  </tbody>
                </table>
              </div>
              <div className="mainfoot">
                <div className="left">
                  {count > 0 && count <= limit ? (
                    <>
                      <p>
                        SHOWING 1-{count} OF {count}
                      </p>
                    </>
                  ) : count > limit ? (
                    <>
                      <p>
                        SHOWING{" "}
                        {offset > 1 ? (offset - 1) * limit + 1 : offset} -
                        {limit * offset > count ? count : limit * offset} OF{" "}
                        {count}
                      </p>
                    </>
                  ) : (
                    <>
                      <p>SHOWING 0 OF 0</p>
                    </>
                  )}
                </div>
                <div className="right">
                  <nav aria-label="Page navigation example">
                    <ul class="pagination">
                      <Stack spacing={2}>
                        <Pagination
                          count={page}
                          page={offset}
                          onChange={(e, p) => setOffset(p)}
                          color="primary"
                        />
                      </Stack>
                    </ul>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>


    </>
  );
};

export default Order;
